<template>  
   
        <v-card>
            <v-card-title>
                <h4 class="headline ma-0 grey--text text--darken-2">Markenübersicht</h4>
            </v-card-title>
            <v-list>                      
                <v-list-tile 
                    v-on:click="preFilterMarken(mk.total)"
                >
                    <v-list-tile-content>
                        <v-badge>
                            <span slot="badge">{{ mk.total.length }}</span>
                            <span >Marken in der WWE MarkenDB</span>
                        </v-badge>
                    </v-list-tile-content>
                </v-list-tile>
                <v-divider class="my-2"></v-divider>
                <v-list-tile 
                    v-on:click="preFilterMarken(mk.created)"
                >
                    <v-list-tile-content>
                        <v-badge>
                            <span slot="badge">{{ mk.created.length }}</span>
                            <span >Neue Marken seit dem letzten Login</span>
                        </v-badge>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile 
                    v-on:click="preFilterMarken(mk.updated)"
                >
                    <v-list-tile-content>
                        <v-badge>
                            <span slot="badge">{{ mk.updated.length }}</span>
                            <span >Bearbeitete Marken seit dem letzten Login</span>
                        </v-badge>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-card>                
    
</template>

<script>



export default {
    
    props: [
        'mk'
    ],
    methods: {
        preFilterMarken: function(arr) {
            this.$emit("preFilterMarken", arr);
        }
    }
    

    
}
</script>

<style>
    
    
</style>




// WEBPACK FOOTER //
// markenCard.vue?57d67e4e